import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const UmlSearchSchema = z.object({
    versionId: z.uuid().optional(),
    tagId: z.uuid().optional(),
    environmentId: z.uuid().optional()
});
export const Route = createFileRoute('/org/$organization/$project/app/$application/uml/')({
    validateSearch: (search)=>UmlSearchSchema.parse(search),
    component: ()=>null
});
